// AccordionComponent.js
import React, { useState } from "react";

const AccordionComponent = ({ title, data, renderContent, accordionId }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading-${accordionId}`} style={{ backgroundColor:'red' }}>
        <button
          className="accordion-button payroll-accordion-btn text-primary p-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse-${accordionId}`}
          // aria-expanded="false"
          aria-expanded={isOpen ? "true" : "false"}
          aria-controls={`collapse-${accordionId}`}
          onClick={toggleAccordion}
        >
          <div className="w-100 d-flex text-black justify-content-between align-items-center" style={{ paddingTop:"5px", paddingBottom:"5px" }}>
            <div style={{ fontSize:"14px" }}>{title}</div>
            <div>
              {isOpen ? (
               <i class="bi bi-dash"></i>
              ) : (
                <i class="bi bi-plus-lg"></i>
              )}
            </div>
          </div>
        </button>
      </h2>
      <div
        id={`collapse-${accordionId}`}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        aria-labelledby={`heading-${accordionId}`}
        data-bs-parent="#accordionExample"
        style={{
          transition: "height 0.7s ease",
        }}
      >
        <div className="accordion-body p-1">
          {data && data.length > 0 ? (
            data.map((item) => renderContent(item))
          ) : (
            <p>No Record Found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccordionComponent;
